/* =====================================================================
   By-the-numbers globe — Natural Shilajit
   COBE WebGL globe of every country we've shipped to, arcs radiating
   from our Los Angeles origin. Key markets carry floating labels that
   track the spin and fade out as they pass to the far side.
   Tuned for contrast against the Deep-Ocean (#023D5B) panel.
   ===================================================================== */
// Loaded at runtime (computed URL) so static bundlers leave it alone.
const COBE_URL = ['https://esm.sh', 'cobe@2.0.1'].join('/');
const ORIGIN = [34.05, -118.24]; // Los Angeles, CA
// Every shipped-to destination [lat, lng] (capital / centroid).
const DESTINATIONS = [
  [41.33, 19.82],   [-8.84, 13.23],   [-34.61, -58.38], [40.18, 44.51],
  [12.52, -69.97],  [-25.27, 133.77], [48.21, 16.37],   [40.41, 49.87],
  [25.06, -77.34],  [26.23, 50.59],   [23.81, 90.41],   [50.85, 4.35],
  [6.50, 2.60],     [32.29, -64.78],  [-16.50, -68.15], [43.85, 18.36],
  [-15.79, -47.88], [42.70, 23.32],   [14.93, -23.51],  [45.42, -75.70],
  [19.29, -81.37],  [-33.45, -70.67], [39.90, 116.40],  [4.71, -74.07],
  [6.83, -5.29],    [45.81, 15.98],   [12.17, -68.99],  [35.17, 33.36],
  [50.08, 14.44],   [55.68, 12.57],   [18.49, -69.93],  [-0.18, -78.47],
  [30.04, 31.24],   [59.44, 24.75],   [-18.12, 178.42], [60.17, 24.94],
  [48.85, 2.35],    [4.92, -52.33],   [-17.68, -149.41],[41.72, 44.78],
  [52.52, 13.40],   [5.60, -0.19],    [36.14, -5.35],   [37.98, 23.73],
  [64.18, -51.69],  [14.63, -90.51],  [49.45, -2.58],   [6.80, -58.16],
  [22.32, 114.17],  [47.50, 19.04],   [64.15, -21.94],  [28.61, 77.21],
  [-6.21, 106.85],  [33.31, 44.36],   [53.35, -6.26],   [31.77, 35.21],
  [41.90, 12.50],   [18.02, -76.80],  [35.68, 139.69],  [49.19, -2.11],
  [31.95, 35.93],   [51.17, 71.45],   [-1.29, 36.82],   [42.66, 21.17],
  [29.38, 47.99],   [56.95, 24.11],   [33.89, 35.50],   [54.69, 25.28],
  [49.61, 6.13],    [-13.97, 33.79],  [3.14, 101.69],   [4.18, 73.51],
  [35.90, 14.51],   [14.61, -61.02],  [-20.16, 57.50],  [19.43, -99.13],
  [47.01, 28.86],   [42.44, 19.26],   [33.97, -6.85],   [-22.56, 17.08],
  [27.72, 85.32],   [52.37, 4.90],    [-41.29, 174.78], [9.08, 7.40],
  [42.00, 21.43],   [59.91, 10.75],   [23.59, 58.41],   [33.69, 73.06],
  [-12.05, -77.04], [14.60, 120.98],  [52.23, 21.01],   [38.72, -9.13],
  [25.29, 51.53],   [-20.88, 55.45],  [44.43, 26.10],   [18.07, -63.05],
  [24.71, 46.68],   [44.79, 20.45],   [1.35, 103.82],   [48.15, 17.11],
  [46.06, 14.51],   [-25.75, 28.19],  [37.57, 126.98],  [40.42, -3.70],
  [6.93, 79.85],    [59.33, 18.07],   [46.95, 7.45],    [25.03, 121.57],
  [-6.79, 39.21],   [13.76, 100.50],  [10.65, -61.52],  [39.93, 32.86],
  [0.35, 32.58],    [50.45, 30.52],   [24.45, 54.38],   [51.51, -0.13],
  [38.90, -77.04],  [-34.90, -56.16], [10.49, -66.88],  [21.03, 105.85],
];
// Named markets that carry a tracking label. Order = priority when two
// labels would collide (earlier wins, later one is suppressed that frame).
const LABELS = [
  { id: 'origin', loc: ORIGIN,          name: 'Main Warehouse · Los Angeles', hub: true },
  { id: 'ca', loc: [45.42, -75.70],  name: 'Canada' },
  { id: 'uk', loc: [51.51, -0.13],   name: 'United Kingdom' },
  { id: 'de', loc: [52.52, 13.40],   name: 'Germany' },
  { id: 'jp', loc: [35.68, 139.69],  name: 'Japan' },
  { id: 'au', loc: [-25.27, 133.77], name: 'Australia' },
  { id: 'br', loc: [-15.79, -47.88], name: 'Brazil' },
  { id: 'in', loc: [28.61, 77.21],   name: 'India' },
  { id: 'ae', loc: [24.45, 54.38],   name: 'U.A.E.' },
  { id: 'fr', loc: [48.85, 2.35],    name: 'France' },
  { id: 'mx', loc: [19.43, -99.13],  name: 'Mexico' },
  { id: 'sg', loc: [1.35, 103.82],   name: 'Singapore' },
  { id: 'za', loc: [-25.75, 28.19],  name: 'South Africa' },
  { id: 'kr', loc: [37.57, 126.98],  name: 'South Korea' },
  { id: 'es', loc: [40.42, -3.70],   name: 'Spain' },
  { id: 'it', loc: [41.90, 12.50],   name: 'Italy' },
  { id: 'cn', loc: [39.90, 116.40],  name: 'China' },
  { id: 'sa', loc: [24.71, 46.68],   name: 'Saudi Arabia' },
  { id: 'nl', loc: [52.37, 4.90],    name: 'Netherlands' },
  { id: 'se', loc: [59.33, 18.07],   name: 'Sweden' },
  { id: 'tr', loc: [39.93, 32.86],   name: 'Turkey' },
  { id: 'ar', loc: [-34.61, -58.38], name: 'Argentina' },
  { id: 'id', loc: [-6.21, 106.85],  name: 'Indonesia' },
  { id: 'eg', loc: [30.04, 31.24],   name: 'Egypt' },
  { id: 'ng', loc: [9.08, 7.40],     name: 'Nigeria' },
  { id: 'ke', loc: [-1.29, 36.82],   name: 'Kenya' },
  { id: 'cl', loc: [-33.45, -70.67], name: 'Chile' },
  { id: 'co', loc: [4.71, -74.07],   name: 'Colombia' },
  { id: 'nz', loc: [-41.29, 174.78], name: 'New Zealand' },
  { id: 'th', loc: [13.76, 100.50],  name: 'Thailand' },
];
function initFallbackGlobe(canvas, error) {
  if (!canvas || canvas.dataset.fallbackGlobe === 'true') return;
  canvas.dataset.fallbackGlobe = 'true';
  if (error) console.warn('COBE globe unavailable; rendering local canvas fallback.', error);
  const frame = canvas.parentElement;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  frame.querySelectorAll('.bynum-pin').forEach((el) => el.remove());
  canvas.style.cursor = 'grab';
  const color = {
    ocean: '#023D5B',
    land: '#3A8EAF',
    line: 'rgba(255,255,255,.18)',
    arc: 'rgba(255,214,10,.72)',
    solar: '#FFD60A',
    white: 'rgba(255,255,255,.88)',
  };
  const labelDests = LABELS.filter((l) => !l.hub);
  const keyPoints = [LABELS[0], ...labelDests.slice(0, 13)];
  const reducedDests = DESTINATIONS.filter((_, index) => index % 2 === 0);
  let width = 0;
  let height = 0;
  let dpr = 1;
  let phi = -0.35;
  let theta = 0.18;
  let dragStart = null;
  let dragPhi = 0;
  let dragTheta = 0;
  let raf = 0;
  function resize() {
    const size = Math.max(1, Math.round(canvas.clientWidth || 1));
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = size;
    height = size;
    canvas.width = Math.round(size * dpr);
    canvas.height = Math.round(size * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function project(location, spin = phi + dragPhi) {
    const lat = location[0] * Math.PI / 180;
    const lon = (location[1] * Math.PI / 180) + spin;
    const cosLat = Math.cos(lat);
    const x = cosLat * Math.sin(lon);
    const y = Math.sin(lat);
    const z = cosLat * Math.cos(lon);
    const cosT = Math.cos(theta + dragTheta);
    const sinT = Math.sin(theta + dragTheta);
    const yy = y * cosT - z * sinT;
    const zz = y * sinT + z * cosT;
    const radius = width * 0.43;
    return {
      x: width / 2 + x * radius,
      y: height / 2 - yy * radius,
      z: zz,
      r: radius,
    };
  }
  function drawGrid(radius) {
    ctx.save();
    ctx.translate(width / 2, height / 2);
    ctx.strokeStyle = color.line;
    ctx.lineWidth = 1;
    for (let i = -60; i <= 60; i += 30) {
      const y = Math.sin(i * Math.PI / 180) * radius;
      const h = Math.cos(i * Math.PI / 180) * radius;
      ctx.beginPath();
      ctx.ellipse(0, -y, h, h * 0.24, 0, 0, Math.PI * 2);
      ctx.stroke();
    }
    for (let i = 0; i < 12; i += 1) {
      ctx.save();
      ctx.rotate((Math.PI / 12) * i);
      ctx.beginPath();
      ctx.ellipse(0, 0, radius * 0.16, radius, 0, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    }
    ctx.restore();
  }
  function drawArc(from, to) {
    const steps = 28;
    let drawing = false;
    ctx.beginPath();
    for (let i = 0; i <= steps; i += 1) {
      const t = i / steps;
      const lat = from[0] + (to[0] - from[0]) * t;
      const lng = from[1] + (to[1] - from[1]) * t;
      const p = project([lat, lng]);
      if (p.z <= -0.08) {
        drawing = false;
        continue;
      }
      const lift = Math.sin(Math.PI * t) * width * 0.05;
      if (!drawing) {
        ctx.moveTo(p.x, p.y - lift);
        drawing = true;
      } else {
        ctx.lineTo(p.x, p.y - lift);
      }
    }
    ctx.stroke();
  }
  function drawLabel(text, point, hub = false) {
    if (point.z < 0.28) return;
    ctx.save();
    ctx.font = hub ? '600 10px Montserrat, Arial, sans-serif' : '500 9px Montserrat, Arial, sans-serif';
    ctx.textBaseline = 'middle';
    const padding = hub ? 9 : 7;
    const label = text.replace('Main Warehouse · ', 'LA · ');
    const tw = ctx.measureText(label).width;
    const x = Math.min(Math.max(point.x - tw / 2 - padding, 8), width - tw - padding * 2 - 8);
    const y = Math.max(18, point.y - 22);
    ctx.fillStyle = hub ? color.solar : 'rgba(2, 28, 42, .78)';
    ctx.strokeStyle = hub ? 'rgba(0,0,0,.18)' : 'rgba(255,255,255,.18)';
    ctx.lineWidth = 1;
    roundRect(x, y - 10, tw + padding * 2, 20, 10);
    ctx.fill();
    ctx.stroke();
    ctx.fillStyle = hub ? '#0A0A0A' : color.white;
    ctx.fillText(label, x + padding, y);
    ctx.restore();
  }
  function roundRect(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }
  function render() {
    ctx.clearRect(0, 0, width, height);
    const radius = width * 0.43;
    const grad = ctx.createRadialGradient(width * 0.38, height * 0.34, width * 0.05, width / 2, height / 2, radius);
    grad.addColorStop(0, 'rgba(78, 154, 186, .98)');
    grad.addColorStop(0.72, color.ocean);
    grad.addColorStop(1, 'rgba(1, 20, 32, .92)');
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.42)';
    ctx.shadowBlur = 42;
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, radius, 0, Math.PI * 2);
    ctx.fillStyle = grad;
    ctx.fill();
    ctx.restore();
    ctx.save();
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, radius, 0, Math.PI * 2);
    ctx.clip();
    drawGrid(radius);
    ctx.strokeStyle = color.arc;
    ctx.lineWidth = 1.15;
    labelDests.slice(0, 16).forEach((l) => drawArc(ORIGIN, l.loc));
    reducedDests.forEach((location) => {
      const p = project(location);
      if (p.z <= 0) return;
      ctx.globalAlpha = 0.25 + p.z * 0.45;
      ctx.beginPath();
      ctx.arc(p.x, p.y, 1.8, 0, Math.PI * 2);
      ctx.fillStyle = color.solar;
      ctx.fill();
    });
    ctx.globalAlpha = 1;
    keyPoints.forEach((market) => {
      const p = project(market.loc);
      if (p.z <= 0) return;
      const hub = Boolean(market.hub);
      ctx.beginPath();
      ctx.arc(p.x, p.y, hub ? 5 : 3.4, 0, Math.PI * 2);
      ctx.fillStyle = hub ? color.solar : color.white;
      ctx.fill();
      ctx.strokeStyle = hub ? 'rgba(255,214,10,.5)' : 'rgba(255,255,255,.28)';
      ctx.lineWidth = hub ? 8 : 5;
      ctx.stroke();
    });
    ctx.restore();
    keyPoints.slice(0, 8).forEach((market) => drawLabel(market.name, project(market.loc), market.hub));
    if (!reduce && !dragStart) phi += 0.0024;
    raf = requestAnimationFrame(render);
  }
  canvas.addEventListener('pointerdown', (event) => {
    dragStart = { x: event.clientX, y: event.clientY };
    canvas.style.cursor = 'grabbing';
  });
  window.addEventListener('pointermove', (event) => {
    if (!dragStart) return;
    dragPhi = (event.clientX - dragStart.x) / 260;
    dragTheta = Math.max(-0.42, Math.min(0.42, (event.clientY - dragStart.y) / 720));
  }, { passive: true });
  const release = () => {
    if (!dragStart) return;
    phi += dragPhi;
    theta = Math.max(-0.34, Math.min(0.48, theta + dragTheta));
    dragPhi = 0;
    dragTheta = 0;
    dragStart = null;
    canvas.style.cursor = 'grab';
  };
  window.addEventListener('pointerup', release, { passive: true });
  window.addEventListener('pointercancel', release, { passive: true });
  resize();
  render();
  if ('ResizeObserver' in window) {
    new ResizeObserver(() => resize()).observe(canvas);
  } else {
    window.addEventListener('resize', resize, { passive: true });
  }
  return () => cancelAnimationFrame(raf);
}
const canvas = document.getElementById('bynumGlobe');
/* Mobile: the globe is hidden via CSS — don't boot the WebGL render loop
   for an invisible canvas. */
const bynumGlobeMobileOff = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
if (canvas && !bynumGlobeMobileOff) (async () => {
  window.__bynumGlobeBooted = true;
  let createGlobe = null;
  try {
    createGlobe = (await import(COBE_URL)).default;
  } catch (error) {
    initFallbackGlobe(canvas, error);
    return;
  }
  const frame = canvas.parentElement;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const THETA = 0.18;
  // ---- markers: hub + labelled key markets (bigger) + every destination ----
  const labelDests = LABELS.filter((l) => !l.hub);
  const markers = [
    { location: ORIGIN, size: 0.085, id: 'origin' },
    ...labelDests.map((l) => ({ location: l.loc, size: 0.05, id: l.id })),
    ...DESTINATIONS.map((d) => ({ location: d, size: 0.022 })),
  ];
  // Arcs only to named markets — unlabelled threads removed to declutter.
  const arcs = labelDests.map((l) => ({ from: ORIGIN, to: l.loc }));
  // ---- build floating label DOM, one per key market ----
  const labelEls = LABELS.map((l) => {
    const el = document.createElement('span');
    el.className = 'bynum-pin' + (l.hub ? ' bynum-pin--hub' : '');
    el.innerHTML = '<span class="bynum-pin-dot"></span>' + l.name;
    el.style.opacity = '0';
    frame.appendChild(el);
    return { ...l, el, vis: 0, prevLeft: null };
  });
  const anchorFor = (id) => {
    const sel = '--cobe-' + id;
    return [...frame.querySelectorAll('div')].find((e) => e.style && e.style.anchorName === sel);
  };
  // ---- pointer / inertia ----
  const pointer = { down: null };
  const last = { x: 0, y: 0, t: 0, has: false };
  const drag = { phi: 0, theta: 0 };
  const vel = { phi: 0, theta: 0 };
  const off = { phi: 0, theta: 0 };
  let paused = false, phi = 0, prevTotalPhi = 0;
  canvas.addEventListener('pointerdown', (e) => {
    pointer.down = { x: e.clientX, y: e.clientY };
    canvas.style.cursor = 'grabbing';
    paused = true; last.has = false;
  });
  window.addEventListener('pointermove', (e) => {
    if (!pointer.down) return;
    drag.phi = (e.clientX - pointer.down.x) / 280;
    drag.theta = (e.clientY - pointer.down.y) / 900;
    const now = Date.now();
    if (last.has) {
      const dt = Math.max(now - last.t, 1), cap = 0.14;
      vel.phi = Math.max(-cap, Math.min(cap, ((e.clientX - last.x) / dt) * 0.3));
      vel.theta = Math.max(-cap, Math.min(cap, ((e.clientY - last.y) / dt) * 0.08));
    }
    last.x = e.clientX; last.y = e.clientY; last.t = now; last.has = true;
  }, { passive: true });
  const release = () => {
    if (pointer.down) {
      off.phi += drag.phi; off.theta += drag.theta;
      drag.phi = 0; drag.theta = 0; last.has = false;
    }
    pointer.down = null; canvas.style.cursor = 'grab'; paused = false;
  };
  window.addEventListener('pointerup', release, { passive: true });
  window.addEventListener('pointercancel', release, { passive: true });
  // ---- globe + render loop ----
  let globe = null, raf = 0, w = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function positionLabels(totalPhi) {
    const dPhi = totalPhi - prevTotalPhi;
    prevTotalPhi = totalPhi;
    const W = canvas.clientWidth || 1;
    const placed = []; // accepted label boxes this frame (px), priority order
    for (const L of labelEls) {
      const a = anchorFor(L.id);
      let target = 0, left = L.lastLeft || 50, top = L.lastTop || 50;
      if (a) {
        const nl = parseFloat(a.style.left);
        const nt = parseFloat(a.style.top);
        if (!Number.isNaN(nl)) {
          left = nl; top = nt;
          // front/back from sign of horizontal motion vs spin direction
          let facing = L.vis > 0.5 ? 1 : 0;
          if (L.prevLeft != null && Math.abs(dPhi) > 2e-4) {
            facing = (left - L.prevLeft) * dPhi > 0 ? 1 : 0;
          }
          L.prevLeft = left;
          // fade near the silhouette so labels don't pile on the limb
          const r = Math.hypot(left - 50, top - 50);
          const edge = Math.max(0, Math.min(1, (45 - r) / 7));
          target = facing ? edge : 0;
        }
      }
      L.lastLeft = left; L.lastTop = top;
      // cache rendered box size once (text is fixed; avoids per-frame reflow)
      if (L.w === undefined && L.el.offsetWidth) { L.w = L.el.offsetWidth; L.h = L.el.offsetHeight; }
      const bw = L.w || 90, bh = L.h || 22;
      // overlap test against higher-priority labels already accepted
      if (target > 0.05) {
        const cx = (left / 100) * W, cy = (top / 100) * W;
        const box = { l: cx - bw / 2 - 3, r: cx + bw / 2 + 3, t: cy - bh * 1.35 - 3, b: cy - bh * 0.35 + 3 };
        const clash = placed.some((p) => !(box.r < p.l || box.l > p.r || box.b < p.t || box.t > p.b));
        if (clash) target = 0; else placed.push(box);
      }
      L.vis += (target - L.vis) * 0.14;
      L.el.style.left = left + '%';
      L.el.style.top = top + '%';
      L.el.style.opacity = L.vis.toFixed(3);
      L.el.style.zIndex = target > 0 ? 3 : 1;
    }
  }
  function build() {
    const size = canvas.clientWidth;
    if (!size) return;
    w = size; dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (globe) globe.destroy();
    cancelAnimationFrame(raf);
    try {
      globe = createGlobe(canvas, {
      devicePixelRatio: dpr,
      width: size * dpr,
      height: size * dpr,
      phi: 0,
      theta: THETA,
      dark: 1,
      diffuse: 1.35,
      mapSamples: 16000,
      mapBrightness: 7.2,
      baseColor: [0.22, 0.55, 0.69],     // luminous teal land
      markerColor: [1, 0.953, 0.318],    // Solar
      glowColor: [0.30, 0.56, 0.69],     // soft ocean halo
      markers,
      arcs,
      arcColor: [1, 0.953, 0.318],
      arcWidth: 0.4,
      arcHeight: 0.42,
      opacity: 0.92,
      });
    } catch (error) {
      initFallbackGlobe(canvas, error);
      return;
    }
    const loop = () => {
      if (!paused) {
        if (!reduce) phi += 0.0032;
        if (Math.abs(vel.phi) > 1e-4 || Math.abs(vel.theta) > 1e-4) {
          off.phi += vel.phi; off.theta += vel.theta;
          vel.phi *= 0.95; vel.theta *= 0.95;
        }
        const tMin = -0.45, tMax = 0.45;
        if (off.theta < tMin) off.theta += (tMin - off.theta) * 0.1;
        else if (off.theta > tMax) off.theta += (tMax - off.theta) * 0.1;
      }
      const totalPhi = phi + off.phi + drag.phi;
      globe.update({ phi: totalPhi, theta: THETA + off.theta + drag.theta });
      positionLabels(totalPhi);
      raf = requestAnimationFrame(loop);
    };
    loop();
  }
  build();
  let rt = 0;
  const ro = new ResizeObserver(() => {
    const size = canvas.clientWidth;
    if (!size) return;
    if (!globe) { build(); return; }
    if (Math.abs(size - w) > 2) { clearTimeout(rt); rt = setTimeout(build, 180); }
  });
  ro.observe(canvas);
})();